export default __webpack_public_path__ + "static/media/ErrorScreen1.4ad2dbad.png";